import React from "react";
import {Container, Text} from "../../../../ui";
import {Dialog, ImgAutoPay} from "../../../bounce-ui";

interface IEnableAutoPayDialogContent {
  activateAutoPayHandler: () => void;
}

export const EnableAutoPayDialogContent = ({activateAutoPayHandler}: IEnableAutoPayDialogContent) => {
  return (
    <Dialog
      image={<ImgAutoPay />}
      title={"Save time with AutoPay"}
      buttonText={"Enable AutoPay"}
      onClick={activateAutoPayHandler}
    >
      <Container sx={{gap: "8px"}}>
        <Text>Have all your payments scheduled and paid automatically instead of manually paying each one.</Text>
        <Text>
          Enable AutoPay for hassle-free management. It's a simple “set it and forget it” solution you can enjoy at no
          extra cost that helps you stay on track and avoid late payments that could impact your plan.
        </Text>
      </Container>
    </Dialog>
  );
};
